import { GraphQLReturn, graphQLSelector } from '@cherre-frontend/data-fetching';
import { graphql } from 'react-relay';
import { getSakuraUsersInfoQuery } from './__generated__/getSakuraUsersInfoQuery.graphql';
import { getSakuraUsersInfoByPropertyAndProviderIdQuery } from './__generated__/getSakuraUsersInfoByPropertyAndProviderIdQuery.graphql';

export const getSakuraUsersInfo = graphQLSelector({
  query: graphql`
    query getSakuraUsersInfoQuery($users: [Int!]!) {
      sakura_user(
        where: { id: { _in: $users } }
        order_by: [{ first_name: asc }, { last_name: asc }]
      ) {
        user_id: id
        first_name
        last_name
      }
    }
  ` as GraphQLReturn<getSakuraUsersInfoQuery>,
  resetCache: false,
  mapResponse: (response) => {
    return response.sakura_user;
  },
});

type SakuraUser =
  getSakuraUsersInfoByPropertyAndProviderIdQuery['response']['sys_properties_flattened_union'][number]['properties_roles_users'][number]['user']['sakura_user'];

export const getSakuraUsersInfoByPropertyId = graphQLSelector({
  query: graphql`
    query getSakuraUsersInfoByPropertyAndProviderIdQuery($property_id: Int!) {
      sys_properties_flattened_union(
        where: { property_id: { _eq: $property_id } }
      ) {
        properties_roles_users(
          where: { is_active: { _eq: true } }
          order_by: [
            { user: { sakura_user: { first_name: asc } } }
            { user: { sakura_user: { last_name: asc } } }
          ]
        ) {
          property_role_id
          property_role {
            property_role_set
          }
          submission_type {
            submission_type_slug
          }
          user {
            sakura_user {
              user_id: id
              first_name
              last_name
            }
          }
        }
      }
    }
  ` as GraphQLReturn<getSakuraUsersInfoByPropertyAndProviderIdQuery>,
  mapResponse: ({ sys_properties_flattened_union: [data] }) => {
    const preparers = data.properties_roles_users.filter(
      ({ property_role }) => property_role.property_role_set === 'preparer'
    );
    const fin_reviewers = data.properties_roles_users.filter(
      ({ property_role, submission_type }) =>
        property_role.property_role_set === 'reviewer' &&
        submission_type &&
        submission_type.submission_type_slug === 'financial'
    );
    const op_reviewers = data.properties_roles_users.filter(
      ({ property_role, submission_type }) =>
        property_role.property_role_set === 'reviewer' &&
        submission_type &&
        submission_type.submission_type_slug === 'operational'
    );

    const mapToSakuraUsers = (value: typeof preparers) =>
      value.map(({ user }) => user.sakura_user as NonNullable<SakuraUser>);

    return {
      preparers: mapToSakuraUsers(preparers).filter(Boolean),
      fin_reviewers: mapToSakuraUsers(fin_reviewers).filter(Boolean),
      op_reviewers: mapToSakuraUsers(op_reviewers).filter(Boolean),
    };
  },
});
